import * as React from 'react';
export const IcGoogle = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.79 11.51a9.373 9.373 0 00-.14-1.2h-8.47v3.51h4.9a4.219 4.219 0 01-1.79 2.77 5.001 5.001 0 01-2 .78c-.71.13-1.44.13-2.15 0a5.46 5.46 0 01-3.93-3.3 3.062 3.062 0 01-.13-.32 5.35 5.35 0 010-3.49A5.61 5.61 0 018.4 8.13a5.29 5.29 0 012.69-1.49 5.36 5.36 0 012.64.1 4.8 4.8 0 011.94 1.15l1.65-1.66c.3-.29.6-.58.88-.88a8.54 8.54 0 00-2.9-1.79A9 9 0 004.14 8a9 9 0 002.44 11.09 9.1 9.1 0 003.27 1.61 9.59 9.59 0 004.61 0 7.93 7.93 0 006-5.65c.319-1.151.43-2.35.33-3.54z'
      fill='currentColor'
    />
  </svg>
);
